import { useFetch, useNotificationContext } from "@4uhub/lib4uhub";
import WhatsAppEmbeddedSignup from "./WhatsAppEmbeddedSignup";
import TicketServService from "../../../../../../../services/ticket.service";
import { memo, useCallback, useEffect, useState } from "react";
import {
  IAuthorizationCode,
  ICurrentStep,
  IErrorMessage,
  IPhoneData,
} from "./models";
import { IRequestData } from "../../../../../../../models/tickets-service";
import { useNavigate } from "react-router-dom";
import { getEIFromUrl } from "../../../../../../../services/establishment.service";
import { useTranslation } from "react-i18next";

const ticketService = new TicketServService();
const translationPath = "chatBot.page.register.ticketServiceWhats.";

interface ILoginButtonProps {
  id: string;
}

export const LoginButton: React.FC<ILoginButtonProps> = memo(({ id }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const eI = getEIFromUrl();
  const { setMessage } = useNotificationContext();

  const { sendRequest } = useFetch(ticketService.whatsappRegister);

  const [requestData, setRequestData] = useState<IRequestData | null>(null);

  const handleSignupComplete = useCallback(
    ({ phoneNumberId, whatsAppBusinessAccountId }: IPhoneData) => {
      console.log(
        "🎉 Signup completo! Phone Number ID:",
        phoneNumberId,
        "WABA ID:",
        whatsAppBusinessAccountId
      );
      setRequestData((oldState) => ({
        id,
        phoneNumberId,
        whatsAppBusinessAccountId,
        authorizationCode: oldState?.authorizationCode || "",
      }));
      setMessage({
        message: t(translationPath + "register_succesfully", {
          phoneNumberId,
          whatsAppBusinessAccountId,
        }),
      });
    },
    [setMessage]
  );

  const handleLoginCallback = useCallback(
    async ({ authorizationCode }: IAuthorizationCode) => {
      console.log("Authorization Code:", authorizationCode);

      setRequestData((oldState) => ({
        id,
        phoneNumberId: oldState?.phoneNumberId || "",
        whatsAppBusinessAccountId: oldState?.whatsAppBusinessAccountId || "",
        authorizationCode,
      }));
    },
    []
  );

  const request = useCallback(async () => {
    if (
      !requestData ||
      !requestData.authorizationCode.length ||
      !requestData.phoneNumberId.length ||
      !requestData.whatsAppBusinessAccountId.length
    )
      return;

    const { success, data } = await sendRequest(requestData);
    if (success && data) {
      console.log("data:", data);
      navigate(
        `/e/${eI}/dashboard/settings/crm/ticketService/whatsappConfig/${id}/${data.id}/edit`
      );
    } else {
      setMessage({
        message: t(translationPath + "sync_error"),
        type: "warning",
      });
    }
  }, [sendRequest, requestData]);

  useEffect(() => {
    request();
  }, [request]);

  const handleSignupCancel = useCallback(
    ({ current_step }: ICurrentStep) => {
      console.warn("❌ Signup cancelado no passo:", current_step);
      setMessage({
        message: t(translationPath + "register_cancel"),
        type: "warning",
      });
    },
    [setMessage]
  );

  const handleSignupError = useCallback(
    ({ error_message }: IErrorMessage) => {
      console.error("🚨 Erro no Signup:", error_message);
      setMessage({
        message: t(translationPath + "register_error", { error_message }),
        type: "error",
      });
    },
    [setMessage]
  );

  return (
    <WhatsAppEmbeddedSignup
      onLoginComplete={handleLoginCallback}
      onSignupComplete={handleSignupComplete}
      onSignupCancel={handleSignupCancel}
      onSignupError={handleSignupError}
    />
  );
});
